<template>
  <div class="d-inline-block">

    <slot name="action-button" v-bind:showModal="showModal">
      <!--
        Use the following slot to replace the show modal button
        <template #action-button="buttonProps">
          <button @click="buttonProps.showModal">Add</button>
        </template>
      -->
      <button @click="showModal" :disabled="disabled" class="btn btn-primary mx-2">
        Create
      </button>
    </slot>

    <b-modal-custom
      v-model="modalDisplay"
      :modal-class.sync="$options.data.themeClass"
      @ok="handleOk"
      @hidden="handleCancel"
      @shown="handleShown"
      @cancel="handleCancel">

      <template #modal-header>
        <h5>{{ modalTitle }}</h5>
        <b-button-close @click="handleCancel">×</b-button-close>
      </template>

      <b-form-group>
        <label>
          <strong>{{ startCase(textFieldName) }}</strong>
        </label>
        <b-form-input ref="firstInput"
                      @keyup.enter.native="handleOk"
                      v-model.trim="$v.modalFields[textFieldName].$model"
                      :state="checkState(textFieldName)"
                      type="text"
                      placeholder=".."/>
        <b-form-invalid-feedback>
          This is a required field and must be at least 3 characters.
        </b-form-invalid-feedback>
      </b-form-group>
    </b-modal-custom>
  </div>
</template>

<script>
import startCase from 'lodash-es/startCase'
import { validationMixin } from 'vuelidate'
import { minLength, required } from 'vuelidate/lib/validators'
import BModalCustom from '@/base_components/BModalCustom'

export default {
  name: 'input-message-box',
  components: {
    BModalCustom,
  },
  mixins: [
    validationMixin,
  ],

  validations() {
    return {
      modalFields: {
        // these values will go to "this.modalFields" implicitly!
        [this.textFieldName]: {
          required,
          minLength: minLength(3),
        },
      },
    };
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    modalTitle: {
      type: String,
      default: 'Details',
    },
    textFieldName: {
      type: String,
      default: 'Name',
    },
    textFieldValue: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      modalDisplay: false,
      modalFields: {
        [this.textFieldName]: '',
      },
      defaultValues: {
        [this.textFieldName]: this.textFieldValue,
      },
    };
  },

  mounted() {
    this.resetFieldsData();
  },

  methods: {
    startCase: startCase,

    showModal() {
      this.modalDisplay = true;
    },

    async handleOk(evt) {
      evt.preventDefault();

      this.$v.modalFields.$touch();
      if(this.$v.modalFields.$anyError) {
        return;
      }
      this.modalDisplay = false;

      this.$emit('data-received', this.modalFields);
      this.resetFieldsData();
    },

    handleCancel(evt) {
      evt.preventDefault();
      this.resetFieldsData();
      this.modalDisplay = false;
    },

    checkState(fieldName) {
      const field = this.$v.modalFields[fieldName];
      return !field.$dirty || !field.$invalid;
    },

    resetFieldsData() {
      Object.keys(this.modalFields).forEach(
        (key) => {
          this.modalFields[key] = this.defaultValues[key] || '';
        }
      );
      // don't show error on empty values on another modal show
      this.$v.modalFields.$reset();
    },

    handleShown() {
      this.$refs.firstInput.$el.focus();
      this.$refs.firstInput.$el.select();
    },
  },

  watch: {
    textFieldValue(value) {
      this.modalFields[this.textFieldName] = value;
    },
  },
}
</script>

<style scoped>

</style>
